// tslint:disable:max-line-length
import * as React from 'react';

export const GalleryNoImageIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <path fill="#C9C9C9" fillRule="nonzero"
          d="M30 8h-5l-3.4-5.2c-.4-.4-1-.8-1.6-.8h-8c-.6 0-1.2.4-1.6.8L7 8H2c-1.2 0-2 .8-2 2v18c0 1.2.8 2 2 2h28c1.2 0 2-.8 2-2V10c0-1.2-.8-2-2-2zM16 24c-3.4 0-6-2.6-6-6s2.6-6 6-6 6 2.6 6 6-2.6 6-6 6z"/>
  </svg>
);
